let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jYY69")).then(() => parcelRequire('6EcmX'));